module.exports = __webpack_public_path__ + "img/logo.47c2d9c0.svg";